var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"return"},[_vm._m(0),_c('div',{staticClass:"return-table"},[_c('Table',{attrs:{"head":_vm.returnOrderTableHead,"width":"1654","height":"550"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"return-top"},[_c('div',{staticClass:"return-top__name"},[_vm._v("退货单")])])
}]

export { render, staticRenderFns }